import {Dispatch} from "redux";

import {IFetchContext} from "@pg-mono/data-fetcher";
import {isEqual, isPlainObject, omit} from "@pg-mono/nodash";
import {createRequestActionTypes, RequestState} from "@pg-mono/request-state";

import {IRPRequestMeta} from "../../../app/rp_request_meta";
import {IRootState} from "../../../store/store";
import {fetchPropertiesCount} from "../../list/actions/fetch_properties_count";
import {OFFER_LIST_CONSTRAINTS} from "../../list/constants/offer_list";
import {getFetchOfferListSubFilterQuery} from "../../list/helpers/sub_type/get_fetch_offer_list_subfilter_query";
import {IOfferListResponse} from "../../list/types/IOfferListResponse";
import {OfferListSubType} from "../../list/types/OfferListSubType";

const OFFER_LIST_MAP_PAGE_SIZE = 1000;
export const OFFER_LIST_MAP_DESKTOP = "map/OFFER_LIST_MAP_DESKTOP";
export const fetchDesktopMapOfferListTypes = createRequestActionTypes(OFFER_LIST_MAP_DESKTOP);

export const fetchMapOfferListMetaDataAtRoute =
    (ctx: IFetchContext<IRPRequestMeta, {offerListSubType?: OfferListSubType}>) => async (dispatch: Dispatch, getState: () => IRootState) => {
        const {offerListSubType} = ctx.match.params;
        const query = getFetchOfferListSubFilterQuery(
            isPlainObject(ctx.prevResult) && ctx.prevResult !== null ? ctx.prevResult : ctx.route.query,
            offerListSubType
        );
        const safeQuery = omit(query, ["s"]);
        const currentRegionCountry = getState().offerListMap.selectedRegion[0]?.country;
        // need to fetch properties count, bcs logic for meta robots depends on it
        const propertiesCount = await dispatch(fetchPropertiesCount(ctx, {...safeQuery, ...OFFER_LIST_CONSTRAINTS, ...{distance: 0}}));
        const {latestQuery, requestState} = getState().offerListMap.list;

        if (requestState !== RequestState.None && isEqual(latestQuery, query)) {
            return false; // prevent fetching
        }

        dispatch({type: fetchDesktopMapOfferListTypes.start, latestQuery: {...query, ...(currentRegionCountry ? {country: currentRegionCountry} : {})}});

        return {
            count: propertiesCount,
            next: null,
            page: 1,
            page_size: OFFER_LIST_MAP_PAGE_SIZE,
            previous: null,
            results: []
        } as IOfferListResponse;
    };
import {Dispatch} from "redux";

import {IFetchContext} from "@pg-mono/data-fetcher";
import {isEqual, isPlainObject, omit} from "@pg-mono/nodash";
import {createRequestActionTypes, RequestState} from "@pg-mono/request-state";

import {IRPRequestMeta} from "../../../app/rp_request_meta";
import {IRootState} from "../../../store/store";
import {fetchPropertiesCount} from "../../list/actions/fetch_properties_count";
import {OFFER_LIST_CONSTRAINTS} from "../../list/constants/offer_list";
import {getFetchOfferListSubFilterQuery} from "../../list/helpers/sub_type/get_fetch_offer_list_subfilter_query";
import {IOfferListResponse} from "../../list/types/IOfferListResponse";
import {OfferListSubType} from "../../list/types/OfferListSubType";

const OFFER_LIST_MAP_PAGE_SIZE = 1000;
export const OFFER_LIST_MAP_DESKTOP = "map/OFFER_LIST_MAP_DESKTOP";
export const fetchDesktopMapOfferListTypes = createRequestActionTypes(OFFER_LIST_MAP_DESKTOP);

export const fetchMapOfferListMetaDataAtRoute =
    (ctx: IFetchContext<IRPRequestMeta, {offerListSubType?: OfferListSubType}>) => async (dispatch: Dispatch, getState: () => IRootState) => {
        const {offerListSubType} = ctx.match.params;
        const query = getFetchOfferListSubFilterQuery(
            isPlainObject(ctx.prevResult) && ctx.prevResult !== null ? ctx.prevResult : ctx.route.query,
            offerListSubType
        );
        const safeQuery = omit(query, ["s"]);
        const currentRegionCountry = getState().offerListMap.selectedRegion[0]?.country;
        // need to fetch properties count, bcs logic for meta robots depends on it
        const propertiesCount = await dispatch(fetchPropertiesCount(ctx, {...safeQuery, ...OFFER_LIST_CONSTRAINTS, ...{distance: 0}}));
        const {latestQuery, requestState} = getState().offerListMap.list;

        if (requestState !== RequestState.None && isEqual(latestQuery, query)) {
            return false; // prevent fetching
        }

        dispatch({type: fetchDesktopMapOfferListTypes.start, latestQuery: {...query, ...(currentRegionCountry ? {country: currentRegionCountry} : {})}});

        return {
            count: propertiesCount,
            next: null,
            page: 1,
            page_size: OFFER_LIST_MAP_PAGE_SIZE,
            previous: null,
            results: []
        } as IOfferListResponse;
    };
